/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactElement, useEffect, useState } from 'react';
import { Box, Button, Grid, Modal, Typography } from '@mui/material';
import useStyles from '../../../assets/styles/components/Modals';
import { ReactComponent as IconInfo } from '../../../assets/images/svg/user/info.svg';

const styleModal = {
  position: 'absolute' as const,
  width: '100%',
  bottom: '0px',
  maxWidth: 680,
  borderRadius: '32px 32px 0px 0px',
  bgcolor: 'background.paper',
  border: '2px solid #ffffff',
  boxShadow: 24,
  p: '10px 24px',
  outline: 'none',
};

type Props = {
  isOpen: boolean;
  title: string;
  message: string;
  handleFn: () => Promise<void>;
  handleFn2?: () => Promise<void>;
  btnNamePrimary: string;
  btnNameSecondary?: string;
  btnCancel?: string;
  onClose: () => void;
  icon?: any;
  heightModal?: string;
};

const ModalConfirmFooter = ({
  isOpen,
  title,
  message,
  handleFn,
  handleFn2 = async () => {
    ('');
  },
  btnNamePrimary,
  btnNameSecondary,
  btnCancel,
  onClose,
  icon = <IconInfo width={35} height={35} />,
  heightModal = '600px',
}: Props): ReactElement => {
  const classeStyle = useStyles();

  const iconVerify = icon || <IconInfo width={35} height={35} />;

  const handleDataModalFn1 = (): void => {
    handleFn();
    onClose();
  };

  const handleDataModalFn2 = (): void => {
    handleFn2();
    onClose();
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={styleModal}>
        <Grid container item xs={12} justifyContent="center">
          {iconVerify}
        </Grid>
        <Grid container item xs={12} justifyContent="center">
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h4"
            className={classeStyle.titleModal}
            style={{ fontWeight: '550' }}
          >
            {title}
          </Typography>
          <Typography
            id="modal-modal-description"
            sx={{ mt: 2 }}
            className={classeStyle.textModal}
          >
            {message}
          </Typography>
        </Grid>

        <Grid
          container
          item
          justifyContent="center"
          alignItems="center"
          textAlign="center"
        >
          <Grid width="80%">
            <Button
              className={classeStyle.btnModal}
              type="submit"
              variant="contained"
              onClick={handleDataModalFn1}
            >
              {btnNamePrimary}
            </Button>
            {btnNameSecondary && (
              <Grid container item xs={12} justifyContent="center">
                <Button
                  className={classeStyle.btnModalSegund}
                  variant="text"
                  onClick={handleDataModalFn2}
                >
                  <p className={classeStyle.textBtnKeepShopping}>
                    {btnNameSecondary}
                  </p>
                </Button>
              </Grid>
            )}
            {btnCancel && (
              <Grid container item xs={12} justifyContent="center">
                <Button
                  className={classeStyle.btnModalWhite}
                  variant="text"
                  onClick={onClose}
                >
                  <p className={classeStyle.textBtnKeepShopping}>{btnCancel}</p>
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default ModalConfirmFooter;
